import { useEffect } from "react";
import { watchHistory } from "../components/javascript/function";
import { UserStore } from "../components/store/store";
import { useHistory } from "react-router-dom";

export default function useWatchHistory(progress) {
  const currentUser = UserStore.useState((s) => s.user);
  const history = useHistory();
  useEffect(() => {
    const unloadPage = (ev) => {
      ev.preventDefault();
      watchHistory(progress, progress.video_id, currentUser.WATCHHISTORY);
    };

    const visibleChange = () => {
      if (document.visibilityState === "hidden") {
        watchHistory(progress, progress.video_id, currentUser.WATCHHISTORY);
      }
    };

    window.addEventListener("beforeunload", unloadPage);
    window.addEventListener("visibilitychange", visibleChange);

    return () => {
      if (history.action === "POP") {
        watchHistory(progress, progress.video_id, currentUser.WATCHHISTORY);
      }
      window.removeEventListener("beforeunload", unloadPage);
      window.removeEventListener("visibilitychange", visibleChange);
    };
  }, [progress, currentUser.WATCHHISTORY, history.action]);
}
